import React, { useState } from 'react'
import ReactQuill from 'react-quill'
import { htmlToMarkdown, markdownToHtml } from 'helpers/textEditor'
import { EditorTitle, EditorWrapper } from './TextEditor.styles'
import { TextEditorProps } from './TextEditor.types'
import 'react-quill/dist/quill.snow.css'

const TextEditor = ({
  placeholder = '',
  showToolbar = true,
  readOnly = false,
  input: { value, onChange },
}: TextEditorProps) => {
  const [editorText, setEditorText] = useState(markdownToHtml(value))

  return (
    <>
      {!!editorText.length && !readOnly && (
        <EditorTitle>{placeholder}</EditorTitle>
      )}
      <EditorWrapper readOnly={readOnly}>
        <ReactQuill
          placeholder={placeholder}
          modules={{
            toolbar: showToolbar && [
              [{ header: [1, 2, 3, false] }],
              ['bold', 'italic', 'underline'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
          }}
          readOnly={readOnly}
          value={editorText}
          onChange={(newValue: string) => {
            setEditorText(newValue)
            onChange?.(htmlToMarkdown(newValue))
          }}
        />
      </EditorWrapper>
    </>
  )
}

export default TextEditor
